export enum RR_CLICK_TYPE {
  RIGHT,
  LEFT,
  MIDDLE,
  CTRL,
}
